import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import statusResources from '@/api/status'

const useSubscriptionServices = () =>
  useQuery(queries.status(), statusResources.get, {
    staleTime: Infinity,
  }).data?.subscriptionServices

export default useSubscriptionServices
